module.exports = __webpack_public_path__ + "img/cross.00f86326.svg";